import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'
import { CustomInput, CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { HEADER_TYPES_ARRAY } from 'src/consumer/constants'
import { getChangedNumberValueFromInput, getNumberStringForInput } from 'src/mentor/helpers/utilityFunctions'

export default function PrintHeaderSettings({ headerSettings, setHeaderSettings }) {
  return (
    <>
      <div className="pt-3">
        <strong>Header Settings</strong>
        <div className="d-flex flex-column gap-1">
          <CustomSelect
            id="headerStyle"
            value={headerSettings?.headerStyle}
            label="Header Type"
            selectType={selectTypes.string}
            options={HEADER_TYPES_ARRAY}
            getOptionValue={(optn) => {
              return optn?.id
            }}
            getOptionLabel={(optn) => {
              return optn?.title
            }}
            onChangeEvent={(e) => {
              setHeaderSettings((prev) => ({
                ...prev,
                headerStyle: e.target.value,
              }))
            }}
          />
        </div>
      </div>
      <div className="pt-1">
        <div className="d-flex flex-column gap-1">
          <FormControlLabel
            control={
              <Checkbox
                checked={headerSettings?.showBlankHeader}
                onChange={(e) => {
                  setHeaderSettings((prev) => ({ ...prev, showBlankHeader: e.target.checked }))
                }}
              />
            }
            label="Show blank header"
          />
        </div>
      </div>
      <div className="pt-1">
        <div className="d-flex flex-column gap-1">
          <CustomInput
            id="headerHeight"
            value={getNumberStringForInput(headerSettings?.headerHeight)}
            type="number"
            label="Header Height in Inches"
            onChange={(e) => {
              setHeaderSettings((prev) => ({
                ...prev,
                headerHeight: getChangedNumberValueFromInput(e.target.value),
              }))
            }}
          />
        </div>
      </div>
    </>
  )
}
